// extracted by mini-css-extract-plugin
export default {"card":"lesson_card__Sz2Br","title":"lesson_title__5XE2w","img":"lesson_img__zmEfC","lesson":"lesson_lesson__6-3Ux"};